import React, { useState } from 'react';
import { Card, Text, Button } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { SupportModal } from 'components/modals/support';

const getCopy = copyFor('solar.canceledStatus');

export const CanceledStatus = () => {
  const [showSupportModal, setShowSupportModal] = useState(false);

  return (
    <Card>
      {showSupportModal && (
        <SupportModal onClose={() => setShowSupportModal(false)} />
      )}
      <Card.Header>
        <Text tag="h2" textStyle="heading700">
          {getCopy('title')}
        </Text>
      </Card.Header>
      <Card.Content>
        <Text>{getCopy('copy')}</Text>
        <Button
          fullWidth
          onClick={() => setShowSupportModal(true)}
          margin={{ top: '20px' }}
        >
          {getCopy('buttons.support')}
        </Button>
      </Card.Content>
    </Card>
  );
};
